import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

interface Props {
  changeFromDate: Function,
  changeToDate: Function,
  fromDate: string,
  toDate: string
}

const DownloadTransactionForm  = ({
  changeFromDate,
  changeToDate,
  fromDate,
  toDate
}: Props) => {
  const { t } = useTranslation();

  return <div>
      <Row>
        <Col md='5'>
          <span>{t('FROM')}</span>
        </Col>
        <Col md='5'>
          <span>{t('TO')}</span>
        </Col>
      </Row>
      <Row>
        <Col md='5'>
          <input onChange={(e: any) => changeFromDate(e.target.value)}
            type="date" id="start" name="trip-start"
            value={fromDate} />
        </Col>
        <Col md='5'>
          <input onChange={(e: any) => changeToDate(e.target.value)}
            type="date" id="start" name="trip-start"
            value={toDate} />
        </Col>
      </Row>
    </div>;
};


export default DownloadTransactionForm;